import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ErrorHandlerService } from '@qaroni-core/services/commons/error-handler/error-handler.service';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

@Injectable()
export class QaroniErrorsInterceptor implements HttpInterceptor {
  private errorHandlerService = inject(ErrorHandlerService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let errorInfo: HttpErrorResponse = null;

    return next.handle(req).pipe(
      tap(
        () => {
          ///next
        },
        error => {
          if (error instanceof HttpErrorResponse) {
            errorInfo = error;
          }
        }
      ),
      finalize(() => {
        if (errorInfo !== null) {
          if (this.validateUrl(errorInfo.url)) {
            this.errorHandlerService.setErrorHandler(errorInfo);
          }
        }
      })
    );
  }

  validateUrl(url: string): boolean {
    if (url.includes('/checks/forgots')) {
      return false;
    }

    return (
      url.includes('/evaluations/') ||
      url.includes('/adjectives/') ||
      url.includes('/departments/') ||
      url.includes('/skills/') ||
      url.includes('/workstation/')
    );
  }
}
